// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap);"]);
// Module
exports.push([module.id, "html{font-size:1rem}#mainNav,#mainNav .v-toolbar__content,#mainNav img{transition:all .2s ease-in-out!important}.v-icon.v-icon.overlay-back{font-size:24px!important}.v-input.text-center input{text-align:center}.v-input input:focus::-moz-placeholder{color:#fff}.v-input input:focus:-ms-input-placeholder{color:#fff}.v-input input:focus::placeholder{color:#fff}.h-100{min-height:100%}", ""]);
// Exports
module.exports = exports;
